import { render, staticRenderFns } from "./HeightSelector.vue?vue&type=template&id=b3f4aaa4"
import script from "./HeightSelector.vue?vue&type=script&lang=js"
export * from "./HeightSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports